import React from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder, formBuilderParams } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.employees.";
const FORM_LABEL_KEY = `${PAGE_LOCALE_KEY}employeeDetail.config.fields`;

const EmployeeOptionConfig = ({ formProps, isEdit, isLoading }) => {
  const { t } = useTranslation();

  const isDisabled = !isEdit || isLoading;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    optForceUpdate: {
      fieldType: "textInput",
      fieldName: "optForceUpdate",
      label: t(`${FORM_LABEL_KEY}.optForceUpdate`),
      disabled: isDisabled,
      config: {
        rules: ["onlyInteger"]
      }
    },
    optNfclocation: {
      fieldType: "checkbox",
      fieldName: "optNfclocation",
      label: t(`${FORM_LABEL_KEY}.optNfclocation`),
      disabled: isDisabled,
    },
    geoFencingEnable: {
      fieldType: "checkbox",
      fieldName: "geoFencingEnable",
      label: t(`${FORM_LABEL_KEY}.geoFencingEnable`),
      disabled: isDisabled,
    },
    optKeepAwake: {
      fieldType: "checkbox",
      fieldName: "optKeepAwake",
      label: t(`${FORM_LABEL_KEY}.optKeepAwake`),
      disabled: isDisabled,
    },
    optPinPadSound: {
      fieldType: "checkbox",
      fieldName: "optPinPadSound",
      label: t(`${FORM_LABEL_KEY}.optPinPadSound`),
      disabled: isDisabled,
    },
    optPinPadVibrator: {
      fieldType: "checkbox",
      fieldName: "optPinPadVibrator",
      label: t(`${FORM_LABEL_KEY}.optPinPadVibrator`),
      disabled: isDisabled,
    },
    optPanToken: {
      fieldType: "checkbox",
      fieldName: "optPanToken",
      label: t(`${FORM_LABEL_KEY}.optPanToken`),
      disabled: isDisabled,
    },
    optReceiptLogo: {
      fieldType: "checkbox",
      fieldName: "optReceiptLogo",
      label: t(`${FORM_LABEL_KEY}.optReceiptLogo`),
      disabled: isDisabled,
    },
    optAutoPrintReceipt: {
      fieldType: "checkbox",
      fieldName: "optAutoPrintReceipt",
      label: t(`${FORM_LABEL_KEY}.optAutoPrintReceipt`),
      disabled: isDisabled,
    },
    optEnableScreenSaver: {
      fieldType: "checkbox",
      fieldName: "optEnableScreenSaver",
      label: t(`${FORM_LABEL_KEY}.optEnableScreenSaver`),
      disabled: isDisabled,
    },
    optAutoStartScreenSaver: {
      fieldType: "checkbox",
      fieldName: "optAutoStartScreenSaver",
      label: t(`${FORM_LABEL_KEY}.optAutoStartScreenSaver`),
      disabled: isDisabled,
    },

    screenTimeout: {
      fieldType: "textInput",
      fieldName: "screenTimeout",
      label: t(`${FORM_LABEL_KEY}.screenTimeout`),
      mandatory: true,
      disabled: isDisabled,
      config: {
        inputType: "number",
        asNumber: true,
        rules: ["onlyInteger", "onlyMaxEightDigits"],
        sanitizers: ["integer", "range:[0,]"]
      }
    },
    checkCardTimeout: {
      fieldType: "textInput",
      fieldName: "checkCardTimeout",
      label: t(`${FORM_LABEL_KEY}.checkCardTimeout`),
      mandatory: true,
      disabled: isDisabled,
      config: {
        inputType: "number",
        asNumber: true,
        rules: ["onlyInteger", "onlyMaxEightDigits"],
        sanitizers: ["integer", "range:[0,]"]
      }
    },
    maxPayTimes: {
      fieldType: "textInput",
      fieldName: "maxPayTimes",
      label: t(`${FORM_LABEL_KEY}.maxPayTimes`),
      mandatory: true,
      disabled: isDisabled,
      config: {
        inputType: "number",
        asNumber: true,
        rules: ["onlyInteger", "onlyMaxEightDigits"],
        sanitizers: ["integer", "range:[0,]"]
      }
    },
    maxRefreshTimes: {
      fieldType: "textInput",
      fieldName: "maxRefreshTimes",
      label: t(`${FORM_LABEL_KEY}.maxRefreshTimes`),
      mandatory: true,
      disabled: isDisabled,
      config: {
        inputType: "number",
        asNumber: true,
        rules: ["onlyInteger", "onlyMaxEightDigits"],
        sanitizers: ["integer", "range:[0,]"]
      }
    }
  }

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.option`)}
      titleVariant="h3"
      padding={formBuilderParams.formSectionLeftPadding}>
      <FormBuilder.Row itemsPerRow={3}>
        {FormBuilder.buildFields({
          formProps, fields: [
            fieldsConfig.optForceUpdate,
            fieldsConfig.optNfclocation,
            fieldsConfig.geoFencingEnable,
            fieldsConfig.optKeepAwake,
            fieldsConfig.optPinPadSound,
            fieldsConfig.optPinPadVibrator,
            fieldsConfig.optPanToken,
            fieldsConfig.optReceiptLogo,
            fieldsConfig.optAutoPrintReceipt,
            fieldsConfig.optEnableScreenSaver,
            fieldsConfig.optAutoStartScreenSaver,
          ]
        })}
      </FormBuilder.Row>
      <FormBuilder.Section
        title={t(`${PAGE_LOCALE_KEY}employeeDetail.config.subtitle.timeout`)}
        titleVariant="h4">
        <FormBuilder.Row itemsPerRow={3}>
          {FormBuilder.buildFields({
            formProps, fields: [
              fieldsConfig.screenTimeout,
              fieldsConfig.checkCardTimeout,
              fieldsConfig.maxPayTimes,
              fieldsConfig.maxRefreshTimes
            ]
          })}
        </FormBuilder.Row>
      </FormBuilder.Section>
    </FormBuilder.Section>
  );
};

export default React.memo(EmployeeOptionConfig);
